import React, { useRef, useState } from "react";
import { Button, Input, Space, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import Style from "./CategoryLevelTwoTable.module.scss";
import { PencilSquare, TrashFill } from "react-bootstrap-icons";

const CategoryLevelTwoTable = ({ btnHandler, data }) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const columns = [
    {
      title: "نام دسته بندی فارسی",
      dataIndex: "namePersian",
      key: "namePersian",
      width: "16%",
      ...getColumnSearchProps("namePersian", "نام دسته بندی فارسی"),
    },
    {
      title: "نام دسته بندی انگلیسی",
      dataIndex: "nameEnglish",
      key: "nameEnglish",
      width: "16%",
      ...getColumnSearchProps("nameEnglish", "نام دسته بندی انگلیسی"),
    },
    {
      title: "کارمزد",
      dataIndex: "categoryFee",
      key: "categoryFee",
      width: "16%",
    },
    {
      title: "تعداد محصولات",
      dataIndex: "count",
      key: "count",
      width: "15%",
    },
    {
      title: "دسته بندی سطح اول",
      dataIndex: "firstLevelCategory",
      key: "firstLevelCategory",
      width: "20%",
      ...getColumnSearchProps("firstLevelCategory", "دسته بندی سطح اول"),
    },
    {
      title: "عملیات",
      dataIndex: "orderBtn",
      key: "orderBtn",
      width: "10%",
      render: (text, record) => (
        <div className={Style.btnHolder}>
          <button
            onClick={() => btnHandler(1, record)}
            className={Style.deleteBtn}
          >
            <TrashFill />
          </button>
          <button onClick={() => btnHandler(2, record)} className={Style.ok}>
            <PencilSquare />
          </button>
        </div>
      ),
    },
  ];
  return (
    <div style={{ width: "100%" }}>
      <Table
        pagination={{ pageSize: 10 }}
        size={"small"}
        columns={columns}
        scroll={{x:1500, y: 400 }}
        dataSource={data && data}
        responsive={true}
      />
    </div>
  );
};

export default CategoryLevelTwoTable;
